<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="inspectionForm" :refresh-key="refreshKey" :show-expand="$route.name == 'auditEditor'">
        <template v-slot:expand="{ item, refreshKey }">
            <component :is="inspection" v-if="$route.name == 'auditEditor'" :item-id="item.id" :refresh-key="refreshKey" :filter="filter" />
        </template>
    </table-base>
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                inspectionForm: () => import('../forms/InspectionForm'),
                inspection: () => import('../editViews/Inspection'),
                headers: [
                    { text: 'Load', value: 'loadId', table: 'loads', form: () => import('../forms/LoadForm') },
                    { text: 'On', value: 'on', format: this.formatDate },
                    { text: 'Number Of Hives', value: 'numberOfHives' },
                    { text: 'Number Of Queenless Hives', value: 'numberOfQueenlessHives' },
                    { text: 'Number Of Failing Hives', value: 'numberOfFailingHives' },
                    { text: 'Number Of Dead Hives', value: 'numberOfDeadHives' },
                    { text: 'Is Sufficient Water', value: 'isSufficientWater' },
                    { text: 'Comments', value: 'comments' },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    loads: [],
                    items: []
                },
                sorting: [
                    { column: "on", direction: "descending" },
                    { column: "loadId", direction: "ascending" },
                ],
                itemsField: 'inspections',
                editPageName: 'inspection',
                apiMethod: 'Inspections',
                claimName: 'Inspections',
                formTitle: 'Inspection',
                excelTitle: 'Inspections',
                hasEditPage: true,
            }
        },
    };
</script>
